import Swiper from "../../assets/.npm/node_modules/swiper";
import Navigation from "../../assets/.npm/node_modules/swiper/modules/navigation.min.mjs";
import Pagination from "../../assets/.npm/node_modules/swiper/modules/pagination.min.mjs";

export default () => {
  const swiperShare = new Swiper(".slider-share", {
    modules: [Navigation, Pagination],
    slidesPerView: 1,
    spaceBetween: 30,
    loop: false,
    navigation: {
      nextEl: ".share-next",
      prevEl: ".share-prev",
    },
    breakpoints: {
      768: {
        slidesPerView: 1.2,
        spaceBetween: 40,
      },
      992: {
        slidesPerView: 1.38,
        spaceBetween: 80,
      },
    },
  });
};
